import  { InnerBlocks } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";

const AgendaHeader = {
  title: __('Agenda header'),
  description: __('Agenda header block for the ABS theme'),
  icon: 'editor-textcolor',
  supports: {
    customClassName: false,
  },
  edit({ className }) {
    const ALLOWED_BLOCKS = [ 'core/heading', 'core/paragraph', 'core/button', 'core/list', 'core/image' ];
    const MY_TEMPLATE = [
      [ 'core/heading', {level: 2, placeholder: __('Insert a description title')}],
      [ 'core/paragraph', { placeholder: __('Insert a short description') } ],
    ];

    return (
        <div className={className}>
          <div className="container">
            <div className={ 'agenda__data' }>
            </div>
            <div className={ 'agenda__description' }>
              <InnerBlocks
                template={ MY_TEMPLATE }
                templateLock={ false }
                allowedBlocks={ ALLOWED_BLOCKS }
              />
            </div>
          </div>
        </div>
    );
  },

  save({ className }) {
    return (
      <div className={className}>
        <div className={ 'container' }>
          <div className={ 'row' }>
            <div className={ 'agenda__data' }></div>
            <div className={ 'agenda__description' }>
              <InnerBlocks.Content />
            </div>
          </div>
        </div>
      </div>
    );
  },
};

export default AgendaHeader;
